/**
 * Converte uma string em uma cor HSL consistente.
 * Útil para gerar cores de avatar baseadas em nomes.
 */
export function stringToColor(str: string): string {
  let hash = 0;
  // Garante que a string não seja vazia para evitar um resultado fixo.
  const sourceStr = str || 'default';
  for (let i = 0; i < sourceStr.length; i++) {
    hash = sourceStr.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = hash % 360;
  return `hsl(${hue}, 70%, 45%)`; // Ajustei a saturação/luminosidade para melhor contraste
}

/**
 * Extrai as iniciais de um nome completo.
 * Ex: "John Doe" -> "JD"
 */
export const getInitials = (name: string | undefined): string => {
  if (!name) return '';

  const parts = name.trim().split(' ').filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0][0]?.toUpperCase() || '';

  // Pega a primeira letra do primeiro e do último nome para um resultado melhor (ex: "Carlos Drummond de Andrade" -> "CA")
  const firstInitial = parts[0][0];
  const lastInitial = parts[parts.length - 1][0];

  return `${firstInitial}${lastInitial}`.toUpperCase();
};
